// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import VueI18n from 'vue-i18n'
import { messages } from './components/common/i18n'
import 'element-ui/lib/theme-chalk/index.css'
import 'babel-polyfill'
import 'es6-promise/auto'
import store from './store/index'
import PdfPreviewer from 'vue-pdfjs-previewer'
import SlideVerify from 'vue-monoplasty-slide-verify';

Vue.use(SlideVerify); //验证码插件
Vue.use(PdfPreviewer)
Vue.use(ElementUI)
Vue.use(VueI18n)

Vue.config.productionTip = false

// 国际化
const i18n = new VueI18n({
  locale: 'zh-CN',
  messages
})

let locale = localStorage.getItem('locale');
if(locale){
  i18n.locale = locale
}

// 路由守卫
router.beforeEach((to, from, next) => {
  let userInfo = JSON.parse(localStorage.getItem("userInfo"))
  let adminerInfo = JSON.parse(sessionStorage.getItem("adminerInfo"))
  if(to.name!='userCenter' && to.name!='admin'){
    next()
  }else if(to.name=='userCenter' && userInfo==null){
    ElementUI.Message.error('请先登录 Please log in')
    next('/')
  }else if(to.name=='admin' && adminerInfo==null){
    ElementUI.Message.error('请先登录 Please log in')
    next('/')
  }else if(to.name=='userCenter' && userInfo.isLogin){
    next()
  }else if(to.name=='admin' && adminerInfo.isLogin){
    next()
  }
  // else if(to.name == 'AddNew' && userInfo == null){
  //   ElementUI.Message.error('请先登录 Please log in')
  //   next('/')
  // }else if(to.name == 'AddNew' && userInfo.isLogin){
  //   next()
  // }
  else{
    next('/')
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  components: { App },
  template: '<App/>',
  created() {
    // 在页面加载时读取sessionStorage
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
    }
    // 在页面刷新时将store保存到sessionStorage
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js